import React from 'react';
import { AlertTriangle, CheckCircle2, Clock } from 'lucide-react';
import { formatDateTime } from '../utils';

const RESOURCE_STATUS_LABELS = {
  ready: 'pronto',
  degraded: 'degradado',
  misconfigured: 'mal configurado',
  unavailable: 'indisponível',
};

const ACK_STATUS_LABELS = {
  applied: 'aplicada',
  partially_applied: 'parcialmente aplicada',
  rejected: 'recusada',
};

/**
 * Diferença entre a versão desejada e a confirmada.
 *
 * É o sinal mais útil da fase de configuração: se o desejado está à frente do
 * confirmado, o connector ainda não aplicou o que o painel já decidiu — e o motivo
 * por recurso aparece logo abaixo.
 */
function ConfigurationStateSummary({ configuration }) {
  if (!configuration) {
    return null;
  }

  const { desired_configuration_version: desired } = configuration;
  const acked = configuration.acked_configuration_version;
  const failing = (configuration.ack_resources || []).filter(
    (resource) => resource.status !== 'ready',
  );

  if (!desired) {
    return (
      <p className="text-xs text-content-muted">
        Sem configuração a entregar: ative o modo private_edge na conta.
      </p>
    );
  }

  const upToDate = configuration.up_to_date;
  const Icon = upToDate && failing.length === 0
    ? CheckCircle2
    : upToDate
      ? AlertTriangle
      : Clock;
  const tone = upToDate && failing.length === 0
    ? 'text-emerald-700'
    : 'text-amber-700';

  return (
    <div className="space-y-2">
      <p className={`text-xs flex items-center gap-1.5 ${tone}`}>
        <Icon className="h-3.5 w-3.5 shrink-0" aria-hidden />
        Configuração v{desired}
        {acked ? ` · confirmada v${acked}` : ' · ainda não confirmada'}
        {configuration.ack_status
          ? ` (${ACK_STATUS_LABELS[configuration.ack_status] || configuration.ack_status})`
          : ''}
        {configuration.acked_at ? ` em ${formatDateTime(configuration.acked_at)}` : ''}
      </p>

      {failing.length > 0 && (
        <ul className="text-xs text-content-muted space-y-1">
          {failing.map((resource) => (
            <li key={resource.resource_ref} className="flex flex-wrap gap-1">
              <code className="font-mono text-[11px] text-content-primary">
                {resource.resource_ref}
              </code>
              <span>
                {RESOURCE_STATUS_LABELS[resource.status] || resource.status}
                {resource.error_code ? ` · ${resource.error_code}` : ''}
              </span>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}

export default ConfigurationStateSummary;
